import { ActionTree } from 'vuex';
import { AuthenticationState } from './types';
import { RootState } from '@/types';
import router from '@/router';
import { userService } from '@/services/user.services';


export const actions: ActionTree<AuthenticationState, RootState> = {
    login({ commit }, {email, password}): any {
        userService.login(email, password)
        .then((response) => {
            const payload: any = response && response.data;
            commit('loggedIn', payload);
            localStorage.setItem('jwt', payload.jwt);
            router.push('/');
            router.go(0);
        }, (error) => {
            commit('logginError', error.response.data);
        });
    },
    logout({ commit }): any {
        userService.logout();
        commit('logout');
        router.push('/');
        router.go(0);
    },
    getUserData({ commit, dispatch }): any {
        userService.getUser()
        .then((response) => {
            const payload: any = response && response.data;
            commit('saveUser', payload);
        }, (error) => {
            if (error.response.status === 404) {
                dispatch('logout');
            }
        });
    },
    updatePassword({}, { data = {} }): any {
        userService.updatePassword(data);
    },
};
